function loadMoreHide() {
    const loadMoreBtn = document.querySelector(".careers-load-more");
    if (loadMoreBtn) {
        const text = loadMoreBtn.dataset.labelloading;
        loadMoreBtn.innerHTML = text;
    }
}

function loadMoreSet(page, pages) {
    const loadMoreBtn = document.querySelector(".careers-load-more");

    if (loadMoreBtn && page && pages) {
        const text = loadMoreBtn.dataset.labelload;
        page = parseInt(page);
        pages = parseInt(pages);
        if (pages > page + 1) {
            loadMoreBtn.dataset.page = (page + 1).toString();
            loadMoreBtn.innerHTML = text;
        } else {
            loadMoreBtn.parentNode.style.display = "none";
        }
    }
}

function getAjaxUrl() {
    const loadMoreBtn = document.querySelector(".careers-load-more");
    return loadMoreBtn.getAttribute("href");
}

function loadItems(_this = null) {
    if (_this) {
        const data = new FormData();
        const page = _this.dataset.page,
            pages = _this.dataset.pages,
            post__not_in = _this.dataset.postnotin;

        data.append("action", "get_careers_list");
        data.append("page", page);
        data.append("pages", pages);
        data.append("post__not_in", post__not_in);

        loadMoreHide();
        const url = getAjaxUrl();
        fetch(url, {
            method: "POST",
            credentials: "same-origin",
            body: data,
        })
            .then((response, group) => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error("Something went wrong");
            })
            .then(function (data) {
                const container = document.querySelector(".info-boxes__list");
                if (container && data) {
                    const parser = new DOMParser();
                    const htmlResponse = parser.parseFromString(data, "text/html");
                    const html = htmlResponse.body.innerHTML;
                    if (html) {
                        container.innerHTML += html;
                    }
                    loadMoreSet(page, pages);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
}

document.body.addEventListener("click", function (e) {
    if (e.target && e.target.matches(".careers-load-more")) {
        e.preventDefault();
        loadItems(e.target);
    }
});
